import ProdutoService from "@/services/ProdutoService";

export const produto = {
  namespaced: true,
  state: {
    Produto: {},
  },
  actions: {
    getProduto({ commit }, payload) {
      return ProdutoService.GetProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProduto({ commit }, payload) {
      return ProdutoService.PostProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProduto({ commit }, payload) {
      return ProdutoService.PutProduto(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProduto({ commit }, payload) {
      return ProdutoService.DeleteProduto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdutoOData({ commit }, payload) {
      return ProdutoService.GetProdutoOData(payload).then(
        (Produto) => {
          return Promise.resolve(Produto);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    validate({ commit }, payload) {
      return ProdutoService.Validate(payload).then(
        (produto) => {
          return Promise.resolve(produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    converter({ commit }, payload) {
      return ProdutoService.Converter(payload).then(
        (produto) => {
          return Promise.resolve(produto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default produto;
